<script setup lang="ts">

import CompleteView from '@presentation/Icons/CompleteView.vue';
import LiveVehicleHealth from '@presentation/Icons/LiveVehicleHealth.vue';
import Reports from '@presentation/Icons/Reports.vue';
import Service from '@presentation/Icons/Service.vue';
import UnlimitedApps from '@presentation/Icons/UnlimitedApps.vue';
import UnlimitedDownloads from '@presentation/Icons/UnlimitedDownloads.vue';

</script>

<template>

    <Page>

        <div class="grid grid-cols-1 lg:grid-cols-8 justify-center items-center gap-8 2xl:gap-16">

            <div class="col-span-1 lg:col-span-3 flex flex-col gap-10 items-center">
            
                <Image src="/images/shared/DealerProposition/carbucks-dashboard-logo.png"
                    class="w-3/5" 
                />

                <Image
                    src="/images/shared/WhatIsCarbucks/product-overview.png"
                    class="w-full mx-auto"
                    floor-shadow
                />

            </div>


            <div class="col-span-1 lg:col-span-5 flex flex-wrap">
            
                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <CompleteView class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">See Your Entire Car Parc</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Provide your team with a comprehensive dashboard of your customers' vehicle 
                        performance and health, allowing you to address their needs 
                        and build trust.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <LiveVehicleHealth class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Live Vehicle Health</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Monitor customer vehicles in real-time, enabling your dealership to 
                        recommend timely maintenance and repairs, enhancing service revenue.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <Service class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Service Conditions</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Stay ahead of upcoming maintenance and service schedules, ensuring 
                        customers return to your dealership for all their needs.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <Reports class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">KPI's &amp; Reporting</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Track and compare dealership performance metrics, driving 
                        improvements and recognizing key areas for growth.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <UnlimitedApps class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Unlimited Apps</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Access a suite of applications designed to optimize dealership 
                        operations and enhance customer satisfaction.
                    </h2>
                </div>

                <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
                    <UnlimitedDownloads class="w-10 2xl:w-16" />
                    <h1 class="font-bold 2xl:my-2 text-sm md:text-base lg:text-lg 3xl:text-2xl">Unlimited Downloads</h1>
                    <h2 class="text-white/60 text-xs 2xl:text-sm 3xl:text-base">
                        Provide your team with ongoing access to updates, tools, and 
                        new features to keep your dealership ahead of the competition.
                    </h2>
                </div>

            </div>

        </div>

    </Page>

</template>